import Footer from "../../footer/Footer";
import "./Archetypes.scss";
import leftarrowblack from "../../../assets/images/left-arrow-black.png";
import resilienticon from "../../../assets/images/resilienticon.png";
import surveillancedesktop from "../../../assets/images/surveillancedesktop.png";
import cross from "../../../assets/images/cross.png";
import right from "../../../assets/images/right.png";
import inprogress from "../../../assets/images/inprogress.png";
import Accordion from "react-bootstrap/Accordion";
const Grants = () => {
  return (
    <>
      <div className="projects">
        <div className="sky-topper">
          <div className="container mobile">
            <div className="custom-row">
              <a href="/Resilience">
                <img
                  src={leftarrowblack}
                  alt="back"
                  className="left-arrow-black"
                />
                <div className="back">Back</div>
              </a>
            </div>
            <div className="page-title">
              Projects requiring grants (non bankable)
            </div>
          </div>
          <div className="container desktop">
            <div className="custom-row">
              <a href="/Resilience">
                <img
                  src={leftarrowblack}
                  alt="back"
                  className="left-arrow-black"
                />
                <div className="back">Back</div>
              </a>
              <div className="page-title">
                Projects requiring grants (non bankable)
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="title projects-title">
            ~$2bn investment to implement{" "}
            <span>high impact policy and public infrastructure projects</span>
          </div>
          <div className="project-desc-title">How Can You Get Involved?</div>
          <div className="project-desc-desc">
            Fund <span>technical preparation and implementation</span> of high
            impact policy and public infrastructure projects
          </div>
          <div className="legends">
            <div>
              <img src={right} alt="right" className="cross-right" />
              <span>Completed</span>
            </div>
            <div>
              <img src={cross} alt="cross" className="cross-right" />
              <span>Not yet started</span>
            </div>
            <div>
              <img src={inprogress} alt="inprogress" className="cross-right" />
              <span>In progress</span>
            </div>
          </div>
          <div className="project-col mobile">
            <div className="project-row">
              <div className="project-desc-title">
                Healthcare Facility Protection
              </div>
              <div className="project-desc-desc">
                Retrofit or relocate <span>~350 public health facilities</span>{" "}
                with flood protection systems and upgrade facilities and
                equipment across these centres i.e., comprehensive health
                centres, primary centres and health posts
              </div>
            </div>
            <div className="investment">INVESTMENT: $300mn</div>
            <div className="project-row">
              <div className="project-desc-title">Schools Protection</div>
              <div className="project-desc-desc">
                Retrofit or relocate <span>~500 public</span> schools with flood
                protection systems
              </div>
            </div>
            <div className="investment">INVESTMENT: $10mn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Vulnerable Population Relocation
              </div>
              <div className="project-desc-desc">
                Relocate{" "}
                <span>320k vulnerable populations in 10 exposed LGAs</span>{" "}
                including empowerment programs for the displaced
              </div>
            </div>
            <div className="investment">INVESTMENT: $500mn</div>
            <div className="project-row">
              <div className="project-desc-title">Water quality management</div>
              <div className="project-desc-desc">
                Adopt regulations that enforce{" "}
                <span>pollution control measures</span> such as limits on
                pollutant discharges, wastewater treatment requirements, etc
              </div>
            </div>
            <div className="investment">INVESTMENT: $20mn</div>
            <div className="project-row">
              <div className="project-desc-title">Emergency Response Fund</div>
              <div className="project-desc-desc">
                Create a Lagos{" "}
                <span>
                  adaptation emergency response fund for post disaster emergency
                  response
                </span>{" "}
                incl. short term relief efforts, repair and reconstruction of
                damaged infrastructure
              </div>
            </div>
            <div className="investment">INVESTMENT: $1bn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Awareness programs on sanitization, hygiene practices
              </div>
              <div className="project-desc-desc">
                Build awareness on practices such as{" "}
                <span>waste disposal and basic hygiene</span> to priority
                communities
              </div>
            </div>
            <div className="investment">INVESTMENT: TBD</div>
            <div className="project-row">
              <div className="project-desc-title">Tree Planting</div>
              <div className="project-desc-desc">
                <span>Plant 50,000 climate-resilient trees</span> annually
                across Lagos to{" "}
                <span>alleviate the impact of extreme heat</span> and the
                associated health and productivity impacts
              </div>
            </div>
            <div className="investment">INVESTMENT: $1.5mn</div>
            <div className="project-row">
              <div className="project-desc-title">Urban Parks</div>
              <div className="project-desc-desc">
                Rehabilitate and maintain existing <span>300+ urban parks</span>{" "}
                across Lagos to foster heat reduction in addition to{" "}
                <span>improving air quality and carbon capture</span>
              </div>
            </div>
            <div className="investment">INVESTMENT: $50mn</div>
            <div className="project-row">
              <div className="project-desc-title">
                Nature-based inland flood solutions
              </div>
              <div className="project-desc-desc">
                Bioswales, rain gardens etc, reducing impact of{" "}
                <span>inland flooding</span>
              </div>
            </div>
            <div className="investment">INVESTMENT: TBD</div>
            <div className="project-row">
              <div className="project-desc-title">Build pumping stations</div>
              <div className="project-desc-desc">
                Actively remove water, maintaining proper water flow and{" "}
                <span>reducing the risk of flooding</span> in vulnerable areas
              </div>
            </div>
            <div className="investment">INVESTMENT: TBD</div>
            <div className="project-row">
              <div className="project-desc-title">
                Build storm water management systems
              </div>
              <div className="project-desc-desc">
                <span>Construct larger stormwater channels</span>, to handle
                increased rainfall and minimize flooding risks in priority areas
              </div>
            </div>
            <div className="investment">INVESTMENT: TBD</div>
            <div className="project-row">
              <div className="project-desc-title">
                Artificial flood barriers
              </div>
              <div className="project-desc-desc">
                Constructing barriers or levees to protect vulnerable areas from{" "}
                <span>flood events due to extreme rainfall</span>
              </div>
            </div>
            <div className="investment">INVESTMENT: TBD</div>
            <div className="project-row">
              <div className="project-desc-title">
                Enforce climate-resilient building codes
              </div>
              <div className="project-desc-desc">
                Stringent building codes in risk areas incorporating{" "}
                <span>climate resilience</span> features, such as elevated
                foundations etc
              </div>
            </div>
            <div className="investment">INVESTMENT: $20mn</div>
          </div>
          <table className="desktop">
            <thead>
              <tr>
                <td>Project Name</td>
                <td>Investment</td>
                <td>Design Study</td>
                <td>Implementation</td>
                <td>Next Steps</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Healthcare Facility Protection
                    </div>
                    <div className="project-desc-desc">
                      Retrofit or relocate{" "}
                      <span>~350 public health facilities</span> with flood
                      protection systems and upgrade facilities and equipment
                      across these centres i.e., comprehensive health centres,
                      primary centres and health posts
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$300mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>

              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">Schools Protection</div>
                    <div className="project-desc-desc">
                      Retrofit or relocate <span>~500 public</span> schools with
                      flood protection systems
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$10mn</div>
                </td>
                <td className="cross-td">
                  <img src={right} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Vulnerable Population Relocation
                    </div>
                    <div className="project-desc-desc">
                      Relocate{" "}
                      <span>
                        320k vulnerable populations in 10 exposed LGAs
                      </span>{" "}
                      including empowerment programs for the displaced
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$500mn</div>
                </td>
                <td className="cross-td">
                  <img src={right} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Policy</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Water quality management
                    </div>
                    <div className="project-desc-desc">
                      Adopt regulations that enforce{" "}
                      <span>pollution control measures</span> such as limits on
                      pollutant discharges, wastewater treatment requirements,
                      etc
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$20mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Policy</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Emergency Response Fund
                    </div>
                    <div className="project-desc-desc">
                      Create a Lagos{" "}
                      <span>
                        adaptation emergency response fund for post disaster
                        emergency response
                      </span>{" "}
                      incl. short term relief efforts, repair and reconstruction
                      of damaged infrastructure
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$1bn</div>
                </td>
                <td className="cross-td">
                  <img src={right} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Policy</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Awareness programs on sanitization, hygiene practices
                    </div>
                    <div className="project-desc-desc">
                      Build awareness on practices such as{" "}
                      <span>waste disposal and basic hygiene</span> to priority
                      communities
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">TBD</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Policy</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">Tree Planting</div>
                    <div className="project-desc-desc">
                      <span>Plant 50,000 climate-resilient trees</span> annually
                      across Lagos to{" "}
                      <span>alleviate the impact of extreme heat</span> and the
                      associated health and productivity impacts
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$1.5mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Policy</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">Urban Parks</div>
                    <div className="project-desc-desc">
                      Rehabilitate and maintain existing{" "}
                      <span>300+ urban parks</span> across Lagos to foster heat
                      reduction in addition to{" "}
                      <span>improving air quality and carbon capture</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$50mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Nature-based inland flood solutions
                    </div>
                    <div className="project-desc-desc">
                      Bioswales, rain gardens etc, reducing impact of{" "}
                      <span>inland flooding</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">TBD</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>

              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Build pumping stations
                    </div>
                    <div className="project-desc-desc">
                      Actively remove water, maintaining proper water flow and{" "}
                      <span>reducing the risk of flooding</span> in vulnerable
                      areas
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">TBD</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>

              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Build storm water management systems
                    </div>
                    <div className="project-desc-desc">
                      <span>Construct larger stormwater channels</span>, to
                      handle increased rainfall and minimize flooding risks in
                      priority areas
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">TBD</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Artificial flood barriers
                    </div>
                    <div className="project-desc-desc">
                      Constructing barriers or levees to protect vulnerable
                      areas from{" "}
                      <span>flood events due to extreme rainfall</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">TBD</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Feasibility</td>
              </tr>
              <tr>
                <td>
                  <div className="project-row">
                    <div className="project-desc-title">
                      Enforce climate-resilient building codes
                    </div>
                    <div className="project-desc-desc">
                      Stringent building codes in risk areas incorporating{" "}
                      <span>climate resilience</span> features, such as elevated
                      foundations etc
                    </div>
                  </div>
                </td>
                <td>
                  <div className="investment">$20mn</div>
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td className="cross-td">
                  <img src={cross} alt="cross" className="cross-right" />
                </td>
                <td>Policy</td>
              </tr>
            </tbody>
          </table>
          <div className="assumptions">
            1. Assumption that 20% of Lagos State health centers and schools are
            public
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Grants;
